<!-- Image -->
<div *ngIf="isShowImage" class="row m-b-sm">
    <div class="col-md-4">
        <label>Image</label>
    </div>
    <div *ngIf="!pageData.imageUrl" class="col-md-8">
        <website-builder-image-upload (imageUpload)="pageData.imageUrl = $event"></website-builder-image-upload>
    </div>
    <div *ngIf="pageData.imageUrl" class="col-md-4">
        <div class="image-wrapper">
            <img [src]="pageData.imageUrl"/>
            <div class="remove-image">
                <i class="fa fa-times-circle fa-2x"
                   aria-hidden="true"
                   (click)="pageData.imageUrl = null">
                </i>
            </div>
        </div>
    </div>
</div>

<!-- Headline -->
<div class="row m-b-sm">
    <div class="col-md-4">
        <label>Headline</label>
    </div>
    <div class="col-md-8">
<textarea class="form-control"
          name="headline"
          resizable="false"
          [(ngModel)]="pageData.headline"
          maxlength="150">
</textarea>
        <span class="number-of-allowed-chars">{{pageData.headline.length}} / 150 Chars</span>
    </div>
</div>

<!--  Text   -->
<div class="row m-b-sm">
    <div class="col-md-4">
        <label>Text</label>
    </div>
    <div class="col-md-8">
<textarea class="form-control"
          name="text"
          resizable="false"
          [(ngModel)]="pageData.text"
          maxlength="65535">
</textarea>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/website-builder-side-editor/section/wb-edit-about/wb-edit-about.component.html